<template>
  <div class="calendar-day">
    <!-- <div class="calendar-day-header">
      <span class="calendar-day-weekend">{{ weekday }}</span>
      <span class="calendar-day-date">{{ day }}</span>
    </div> -->
    <all-day-task
      :tasks="allDayTasks"
      :curDate="curDate"
    />
    <div
      ref="container"
      class="calendar-day-panel"
    >
      <hours-list>
        <div class="calendar-day-tasks">
          <task-block
            :tasks="normalTasks"
            @createTask="createTask"
            @resetTask="resetTask"
          />
        </div>
      </hours-list>
      <current-time-line v-if="isToday" />
    </div>
  </div>
</template>
<script>
import solarLunar from 'solarlunar'
import calendarUtil from '@/utils/calendar'
import mixin from '@/mixins/calendar'
import _ from 'lodash'
import HoursList from '../week/hoursList'
import CurrentTimeLine from '../week/currentTimeLine'
import AllDayTask from './allDayTask'
import TaskBlock from '../tasks/taskBlock'
export default {
  name: 'CalendarDaysView',
  mixins: [mixin],
  components: {
    HoursList,
    AllDayTask,
    TaskBlock,
    CurrentTimeLine
  },
  props: {
    curDate: {
      type: String,
      default: moment().format('YYYY-MM-DD')
    }
  },
  data () {
    return {
      weekdays: calendarUtil.getFullCnWeek('星期'),
      weekday: '',
      day: '',
      isToday: false,
      allDayTasks: [],
      normalTasks: []
    }
  },
  watch: {
    curDate () {
      this.setParams()
      this.setTodayLine()
      // this.updatelabel()
    },
    '$store.state.calendar.tasks': {
      handler (newer, older) {
        this.filterTasks(newer)
        if (newer && newer.length) {
          let loaded = this.requestChanged || older.length === 0
          loaded && this.scrollToNow(newer)
          this.requestChanged = false
        }
      },
      deep: true
    },
    '$store.state.calendar.reqParams': {
      handler (newer, older) {
        if (this.requstParams !== JSON.stringify({ ...newer, random: '' })) {
          this.requestChanged = true
        }
        this.requstParams = JSON.stringify({ ...newer, random: '' })
      },
      deep: true
    }
  },
  created () {
    this.setParams()
    this.setTodayLine()
    // this.updateLabel()
  },
  methods: {
    setParams () {
      this.$store.commit('updateCalendarParams', {
        rangeFrom: this.curDate,
        rangeTo: this.curDate
      })
    },
    setTodayLine () {
      this.isToday = moment(this.curDate, 'YYYY-MM-DD').isSame(moment(), 'day')
    },
    /**
     * 过滤出全天任务和非全天任务
     * 开始结束时间不在同一天的任务或者dayType==1归为全天任务
     */
    filterTasks (tasks) {
      this.allDayTasks = []
      this.normalTasks = []
      tasks.map(item => {
        if (!moment(item.endTime || item.dueTime).isSame(moment(item.startTime || item.dueTime), 'day') || item.dayType === 1) {
          this.allDayTasks.push(item)
        } else {
          this.normalTasks.push(item)
        }
      })
    },
    /**
     * 滑动新建任务
     */
    createTask (params) {
      const _params = this.transformDate(params, this.curDate)
      this._createTask(_params)
    },
    resetTask (params) {
      const _params = this.transformDate(params, this.curDate)
      let keys = ['id', 'timeType', 'dayType', 'repeatRule']
      keys.map((key) => {
        _params[key] = params[key]
      })
      this._resetTaskTime(_params)
    },
    /**
    * 滚动到当前时间
    */
    scrollToNow (tasks) {
      if (!tasks[0]) {
        return
      }
      const orderedTasks = _.orderBy(tasks, ['startTime', 'dueTime', 'endTime'], ['asc', 'asc', 'desc'])
      const startTime = orderedTasks[0].startTime || orderedTasks[0].dueTime
      const startMoment = moment(startTime)
      let top = startMoment.diff(moment(startTime).startOf('day'), 'minutes')
      this.$refs.container.scrollTo(0, top)
    },
    updateLabel () {
      const currMoment = moment(this.curDate, 'YYYY-MM-DD')
      const item = solarLunar.solar2lunar(currMoment.get('year'), currMoment.get('month') + 1, currMoment.get('date'))
      this.weekday = `${this.weekdays[currMoment.weekday()]}`
      this.day = `${item.cMonth}.${item.cDay}`
    }
  }
}
</script>
<style lang="stylus">
.calendar-day
  margin-top 15px
  &-panel
    position relative
    height 300px
    margin-right 18px
    overflow auto
  &-weekend
    font-size 16px
    color #333
  &-date
    margin-left 20px
  &-tasks
    position absolute
    margin-left 66px
    top 4px
    bottom 0
    right 0
    left 0
</style>
